export default __webpack_public_path__ + "static/media/upstateLogo.cc720df7.svg";